export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11216_CALL_IN_PROGRESS': 'Call in progress',
    '_11228_REJOIN_CALL': 'Rejoin call',
    '_11229_END_CALL': 'End call'
};
